import { Controller } from "@hotwired/stimulus"
import DOMPurify from "dompurify"
import { marked } from "marked"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.render()
  }

  render() {
    let rawContent = this.contentTarget.innerText || this.contentTarget.textContent
    if (rawContent) {
      rawContent = rawContent.trim()
      this.contentTarget.innerHTML = DOMPurify.sanitize(marked.parse(rawContent))
      // Добавляем классы для стилизации markdown (Tailwind Typography)
      this.contentTarget.classList.add("prose", "prose-sm", "max-w-none")
      // Убираем whitespace-pre-wrap, так как markdown сам форматирует текст
      this.contentTarget.classList.remove("whitespace-pre-wrap")
    }
  }
}
